var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("template", { slot: "header" }, [_vm._v("Ajax 错误")]),
      _c("p", { staticClass: "d2-mt-0" }, [
        _vm._v(
          "请打开浏览器控制台，然后点击下面的按钮，尝试访问一个不存在的网络地址"
        )
      ]),
      _c(
        "el-button",
        { attrs: { type: "danger" }, on: { click: _vm.handleClick } },
        [_vm._v("请求错误的地址")]
      ),
      _c("p", [
        _vm._v(
          '此错误已经被记录在日志页面，并在页面右上"日志按钮"区域显示提示信息'
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }